import {
    BASEMENT_DEVELOPMENT_TYPES,
    BASEMENT_TYPES,
    ROOF_COVERING_TYPES,
    ROOF_DEVELOPMENT_TYPES,
    ROOF_SHAPES,
    WINDOW_TYPES,
} from 'cpool-constants';
import { z } from 'zod';

import { schemaUniqueEnumList } from './schemaUniqueEnumList';

export const schemaBaubeschreibungDachKellerFenster = z.object({
    dachausbau: z.nativeEnum(ROOF_DEVELOPMENT_TYPES).nullish().default(null),
    dacheindeckung: z.nativeEnum(ROOF_COVERING_TYPES).nullish().default(null),
    dachform: z.nativeEnum(ROOF_SHAPES).nullish().default(null),
    fenster: schemaUniqueEnumList(WINDOW_TYPES, 'Window types must be unique'),
    kellerart: z.nativeEnum(BASEMENT_TYPES).nullish().default(null),
    kellerausbau: z.nativeEnum(BASEMENT_DEVELOPMENT_TYPES).nullish().default(null),
});

export type SchemaBaubeschreibungDachKellerFenster = z.infer<typeof schemaBaubeschreibungDachKellerFenster>;
